import React, { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../services/api";
import "./ProductPage.css";
import {
  FaEdit,
  FaTrashAlt,
} from "react-icons/fa";


const ProductPage = () => {
  const { id: businessId } = useParams();
  const [products, setProducts] = useState([]);
  const [editingProductId, setEditingProductId] = useState(null);
  const [form, setForm] = useState({
    item: "",
    item_size: "",
    unit: "",
    description: "",
    price: ""
  });
  const navigate = useNavigate();

  const fetchProducts = useCallback(async () => {
    const { data } = await api.get(`/business/${businessId}/products`);
    setProducts(data);
  }, [businessId]);

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  

  const handleChange = (e) => {
  const { name, value, type, checked } = e.target;
  setForm((prev) => ({
    ...prev,
    [name]: type === "checkbox" ? checked : value,
  }));
};


  const addProduct = async () => {
    await api.post(`/business/${businessId}/products`, form);
    setForm({ item: "", item_size: "", unit: "", description: "", price: "" });
    fetchProducts();
  };

  const disableProduct = async (productId) => {
    await api.put(`/products/${productId}/disable`);
    fetchProducts();
  };

  const updateProduct = async () => {
  await api.put(`/products/${editingProductId}`, form);
  setForm({ item: "", item_size: "", unit: "", description: "", price: "" });
  setEditingProductId(null);
  fetchProducts();
};


  return (
    <div className="product-container">
    
<button className="avg-cogs-btn save-btn" onClick={() => navigate(-1)}>
  ← Back
</button>

      <h3>Products</h3>

      

      <div className="product-form">
  <div className="product-row">
    <input name="item" placeholder="Item" value={form.item} onChange={handleChange} />
    <input name="item_size" placeholder="Size" value={form.item_size} onChange={handleChange} />
    <input name="unit" placeholder="Unit (e.g. pcs, kg)" value={form.unit} onChange={handleChange} />
  </div>

  <div className="product-row">
  <input name="price" type="number" step="0.01" placeholder="Price" value={form.price} onChange={handleChange} />
    <textarea name="description" placeholder="Description" value={form.description} onChange={handleChange} />
  </div>

  <div className="product-row product-actions">
    <label>
      <input
        type="checkbox"
        name="taxable"
        checked={form.taxable}
        onChange={handleChange}
      />
      Sales Tax Applicable
    </label>

    {editingProductId ? (
      <>
        <button onClick={updateProduct}>Update Product</button>
        <button onClick={() => {
          setForm({ item: "", item_size: "", unit: "", description: "", price: "", taxable: false });
          setEditingProductId(null);
        }}>Cancel</button>
      </>
    ) : (
      <button onClick={addProduct}>Add Product</button>
    )}
  </div>
</div>


      <table className="product-table">
        <thead>
          <tr>
            <th>Item</th>
            <th className="pro-size">Size</th>
            <th className="pro-unit">Unit</th>
            <th>Price</th>
            <th className="pro-desc">Description</th><th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {products.map((p) => (
            <tr key={p.id}>
              <td>{p.item}</td>
              <td className="pro-size">{p.item_size}</td>
              <td className="pro-unit">{p.unit}</td>
              <td>${p.price}</td>
              <td className="pro-desc">{p.description}</td>
              <td><button style={{backgroundColor:"white", color:"blue"}} onClick={() => {
                setForm({ ...p });
                setEditingProductId(p.id);
                }}><FaEdit/></button>
                <button style={{backgroundColor:"white", color:"#c2185b"}} onClick={() => disableProduct(p.id)}><FaTrashAlt/></button>

                </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProductPage;
